'use strict';

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
},
    _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _styles = require('../styles'),
    _themes = require('../themes'),
    _propTypes3 = require('../propTypes'),
    _FormControl = require('../FormControl'),
    _FormControl2 = _interopRequireDefault(_FormControl),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {};
Styled.div = {}, Styled.textarea = _styledComponents2.default.textarea.withConfig({
  displayName: 'TextAreaControl__textarea'
})(['', ';box-sizing:border-box;width:', ';max-width:100%;min-height:', ';padding:5px 12px;background-color:', ';background-image:', ';background-position:', ';background-repeat:no-repeat;background-size:', ';border-color:', ';border-style:', ';border-width:', ';border-radius:', ';color:', ';font-family:', ';font-size:', ';font-weight:', ';-webkit-font-smoothing:antialiased;line-height:1.5;white-space:pre-wrap;vertical-align:top;transition-property:none;transition-duration:', ';transition-timing-function:', ';appearance:none;resize:none;word-wrap:break-word;&::-moz-placeholder{opacity:1;}&::placeholder{color:', ';font-weight:', ';}&:required{box-shadow:none;}&:read-only{background-color:', ';color:', ';}&:focus{outline:none;border-color:', ';box-shadow:', ';}&[aria-invalid]{padding-right:38px;background-image:', ';border-color:', ';box-shadow:none;&:focus{background-image:', ';border-color:', ';box-shadow:', ';}}&:disabled{background-color:', ';border-color:', ';color:', ';cursor:default;}'], function (props) {
  return props.inheritStyles ? '' : _styles.resetInheritedStyles;
}, function (props) {
  return props.sc.fullWidth ? '100%' : (0, _themes.getStyle)('TextAreaControl_width');
}, function (props) {
  return props.theme.vstui.rem((0, _themes.getStyle)('InputControl_minHeight_' + props.sc.size)(props));
}, (0, _themes.getStyle)('TextAreaControl_backgroundColor'), (0, _themes.getStyle)('TextAreaControl_backgroundImage'), function (props) {
  return (0, _themes.getStyle)('TextAreaControl_backgroundPosition_' + props.sc.size)(props);
}, (0, _themes.getStyle)('TextAreaControl_backgroundSize'), (0, _themes.getStyle)('TextAreaControl_borderColor'), (0, _themes.getStyle)('TextAreaControl_borderStyle'), (0, _themes.getStyle)('TextAreaControl_borderWidth'), (0, _themes.getStyle)('TextAreaControl_borderRadius'), (0, _themes.getStyle)('TextAreaControl_color'), (0, _themes.getStyle)('TextAreaControl_fontFamily'), function (props) {
  return props.theme.vstui.rem((0, _themes.getStyle)('TextAreaControl_fontSize_' + props.sc.size)(props));
}, (0, _themes.getStyle)('TextAreaControl_fontWeight'), function (props) {
  return props.theme.vstui.transition.duration.shortest;
}, function (props) {
  return props.theme.vstui.transition.easing.easeIn;
}, (0, _themes.getStyle)('TextAreaControlPlaceholder_color'), (0, _themes.getStyle)('TextAreaControlPlaceholder_fontWeight'), (0, _themes.getStyle)('TextAreaControl_backgroundColor_readOnly'), (0, _themes.getStyle)('TextAreaControl_color_readOnly'), (0, _themes.getStyle)('TextAreaControl_borderColor_focus'), (0, _themes.getStyle)('TextAreaControl_boxShadow_focus'), (0, _themes.getStyle)('TextAreaControl_backgroundImage_invalid'), (0, _themes.getStyle)('TextAreaControl_borderColor_invalid'), (0, _themes.getStyle)('TextAreaControl_backgroundImage_invalidFocus'), (0, _themes.getStyle)('TextAreaControl_borderColor_invalidFocus'), (0, _themes.getStyle)('TextAreaControl_boxShadow_focus'), (0, _themes.getStyle)('TextAreaControl_backgroundColor_disabled'), (0, _themes.getStyle)('TextAreaControl_borderColor_disabled'), (0, _themes.getStyle)('TextAreaControl_color_disabled')), Styled.textarea.displayName = 'Styled_textarea';

var TextAreaControl = function (_PureComponent) {
  function TextAreaControl(props) {
    _classCallCheck(this, TextAreaControl);

    var _this = _possibleConstructorReturn(this, (TextAreaControl.__proto__ || Object.getPrototypeOf(TextAreaControl)).call(this, props));

    return _this.handleFormControlRef = _this.handleFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this.renderContent = _this.renderContent.bind(_this), _this.formValidation = {
      missingText: function missingText() {
        return 'Please fill out this field.';
      },
      tooLong: function tooLong(maxLength, currentLength) {
        return 'Please shorten this text to ' + maxLength + ' characters or less (you are currently using ' + currentLength + ' characters).';
      },
      tooShort: function tooShort(minLength, currentLength) {
        return 'Please use at least ' + minLength + ' characters (you are currently using ' + currentLength + ' characters).';
      }
    }, _this;
  }

  return _inherits(TextAreaControl, _PureComponent), _createClass(TextAreaControl, [{
    key: 'getValidationMessage',
    value: function getValidationMessage(validity) {
      var _props = this.props,
          maxLength = _props.maxLength,
          minLength = _props.minLength,
          value = _props.value;
      return validity.valueMissing ? this.formValidation.missingText() : validity.tooLong ? this.formValidation.tooLong(maxLength, value.length) : validity.tooShort ? this.formValidation.tooShort(minLength, value.length) : '';
    }
  }, {
    key: 'validate',
    value: function validate(callback) {
      this.formControl.validate(callback);
    }
  }, {
    key: 'handleFormControlRef',
    value: function handleFormControlRef(node) {
      this.formControl = node;
    }
  }, {
    key: 'handleValidate',
    value: function handleValidate(validity) {
      var _ref2 = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          callback = _ref2.callback,
          onlyValidateIfValid = _ref2.onlyValidateIfValid,
          _ref = arguments[2],
          updateValidationState = _ref.updateValidationState,
          value = _ref.value,
          _props2 = this.props,
          onValidate = _props2.onValidate,
          validate = _props2.validate,
          passedDefaultValidation = validity.valid,
          defaultValidationMessage = this.getValidationMessage(validity),
          customValidationMessagePromise = Promise.resolve(validate ? validate(value) : ''),
          update = function update(valid, validationMessage) {
        (!onlyValidateIfValid || onlyValidateIfValid && valid) && updateValidationState(valid, validationMessage, onValidate);
      };

      update(passedDefaultValidation, defaultValidationMessage), passedDefaultValidation ? customValidationMessagePromise.then(function (customValidationMessage) {
        var passedCustomValidation = !customValidationMessage;
        update(passedCustomValidation, customValidationMessage), callback && callback(passedCustomValidation, customValidationMessage);
      }) : callback && callback(passedDefaultValidation, defaultValidationMessage);
    }
  }, {
    key: 'renderContent',
    value: function renderContent(_ref3) {
      var defaultValue = _ref3.defaultValue,
          invalid = _ref3.invalid,
          handleBlur = _ref3.handleBlur,
          handleChange = _ref3.handleChange,
          handleNativeFormControlRef = _ref3.handleNativeFormControlRef,
          value = _ref3.value,
          _props3 = this.props,
          className = _props3.className,
          disabled = _props3.disabled,
          fullWidth = _props3.fullWidth,
          inheritStyles = _props3.inheritStyles,
          labelledBy = _props3.labelledBy,
          nativeFormControlRefIgnored = _props3.nativeFormControlRef,
          onValidateIgnored = _props3.onValidate,
          placeholder = _props3.placeholder,
          readOnly = _props3.readOnly,
          required = _props3.required,
          rows = _props3.rows,
          secondary = _props3.secondary,
          size = _props3.size,
          themeProp = _props3.theme,
          otherProps = _objectWithoutProperties(_props3, ['className', 'disabled', 'fullWidth', 'inheritStyles', 'labelledBy', 'nativeFormControlRef', 'onValidate', 'placeholder', 'readOnly', 'required', 'rows', 'secondary', 'size', 'theme']),
          theme = (0, _componentTheme2.default)(themeProp),
          conditionalProps = {};

      return invalid && (conditionalProps['aria-invalid'] = !0), required && (conditionalProps['aria-required'] = !0), _react2.default.createElement(Styled.textarea, _extends({}, otherProps, conditionalProps, {
        "aria-labelledby": labelledBy,
        className: className,
        defaultValue: defaultValue,
        disabled: disabled,
        innerRef: handleNativeFormControlRef,
        onBlur: handleBlur,
        onChange: handleChange,
        placeholder: placeholder,
        readOnly: readOnly,
        required: required,
        rows: rows,
        sc: {
          fullWidth: fullWidth,
          inheritStyles: inheritStyles,
          secondary: secondary,
          size: size
        },
        theme: theme,
        value: value
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          defaultValue = _props4.defaultValue,
          nativeFormControlRef = _props4.nativeFormControlRef,
          onBlur = _props4.onBlur,
          onChange = _props4.onChange,
          theme = _props4.theme,
          value = _props4.value;
      return _react2.default.createElement(_FormControl2.default, {
        defaultValue: defaultValue,
        nativeFormControlRef: nativeFormControlRef,
        onFormControlBlur: onBlur,
        onFormControlChange: onChange,
        onValidate: this.handleValidate,
        ref: this.handleFormControlRef,
        render: this.renderContent,
        theme: theme,
        value: value
      });
    }
  }]), TextAreaControl;
}(_react.PureComponent);

TextAreaControl.propTypes = {
  className: _propTypes2.default.string,
  defaultValue: function defaultValue(props, propName, componentName) {
    if (props[propName] !== void 0) {
      if (props.value !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');
      if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
    }
  },
  disabled: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  inheritStyles: _propTypes2.default.bool,
  labelledBy: _propTypes2.default.string,
  maxLength: function maxLength(props, propName, componentName) {
    if (props[propName] !== void 0 && 'number' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number`.');
  },
  minLength: function minLength(props, propName, componentName) {
    if (props[propName] !== void 0 && 'number' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number`.');
  },
  nativeFormControlRef: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onValidate: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  rows: _propTypes2.default.number,
  secondary: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  theme: _propTypes3.themeShape,
  validate: _propTypes2.default.func,
  value: function value(props, propName, componentName) {
    if (props[propName] !== void 0) {
      if (props.defaultValue !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');
      if (void 0 === props.onChange) throw new Error('Please add prop `onChange` to `' + componentName + '`. Prop `value` has been set, which makes this a controlled component.');
      if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
    }
  }
}, TextAreaControl.defaultProps = {
  rows: 3,
  size: 'medium',
  theme: (0, _themes.createTheme)(),
  validate: function validate() {
    return '';
  }
}, TextAreaControl.displayName = 'TextAreaControl';
var TextAreaControlWithTheme = (0, _themes.withTheme)(TextAreaControl);
TextAreaControlWithTheme.WrappedComponent = TextAreaControl, exports.default = TextAreaControlWithTheme;